import React from 'react';

function CircularChart({ value = 0, total = 100, circumferenceColor }) {
  const color = circumferenceColor;
  const radius = 12; // very small radius
  const circumference = 2 * Math.PI * radius;
  const progress = (value / total) * 100;

  const strokeDashoffset = circumference - (circumference * progress) / 100;

  return (
    <div
      style={{
        textAlign: 'center',
        position: 'relative',
        width: '30px',
        height: '30px',
      }}
    >
      <svg width="30" height="30">
        {/* Background circle */}
        <circle
          cx="15"
          cy="15"
          r={radius}
          stroke="#DBDBDB"
          strokeWidth="2"
          fill="none"
        />
        {/* Progress circle */}
        <circle
          cx="15"
          cy="15"
          r={radius}
          stroke={color}
          strokeWidth="2"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform="rotate(-90 15 15)"
        />
      </svg>
    </div>
  );
}

export default CircularChart;
